import React from "react";
import "./Footer.css"; // Import CSS for styling
import QR from "../assets/Qrcode.png";
import { useTranslation } from "react-i18next";
import QR2 from "../assets/QrWhatthefuckisup.png";

const Footer = () => {
	const { t } = useTranslation();
	return (
		<footer className="footer">
			<div className="footer-content">
				<div className="footer-section">
					<h4>{t("FooterContacts")}</h4>
					<p>{t("FooterContactText")}</p>
					<p>{t("FooterContactMail")}</p>
				</div>
				{/* Work Schedule Section */}
				<div className="footer-section">
					<h4>{t("FooterWorkSchedule")}</h4>
					<p>{t("FooterWorkScheduleText")}</p>
					<p>{t("FooterWorkScheduleText2")}</p>
				</div>
				{/* Address Section */}
				<div className="footer-section">
					<h4>{t("FooterAddress")}</h4>
					<p>{t("FooterAddressText")}</p>
				</div>

				<div className="footer-section">
					<h4>{t("FooterFollowUs")}</h4>
					<div className="qr-code-placeholder-container">
						{/* QR codes */}
						<div className="qr-code-placeholder">
							<img src={QR} alt="QR Code 1" />
						</div>
						<div className="qr-code-placeholder">
							<img src={QR2} alt="QR Code 2" />
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
